import { isNil } from 'lodash';

import { useSubscriptionsInfo, useUpcomingInvoice } from '@/api/subscriptions';
import { DisplayCurrency } from '@/components/DisplayCurrency';
import { AccountBalanceCard } from '@/components/subscriptions/AccountBalanceCard';
import { CurrentSubscriptionPeriodCard } from '@/components/subscriptions/CurrentSubscriptionPeriodCard';
import { SummaryCard, SummaryCardBody, SummaryCardButton, SummaryCardRow } from '@/components/ui/SummaryCard';

export const BillingProjectionSection = () => {
    const { data: subscriptionInfo } = useSubscriptionsInfo();
    const { data: upcomingInvoice, isLoading: isUpcomingInvoiceLoading } = useUpcomingInvoice({
        subscriptionId: subscriptionInfo?.data?.[0]?.id as string,
        config: { enabled: Boolean(subscriptionInfo?.data?.[0]?.id) },
    });

    const nextInvoiceTotalCents = upcomingInvoice?.data?.total;

    return (
        <SummaryCardRow sx={{ width: 1 }}>
            <AccountBalanceCard />
            <CurrentSubscriptionPeriodCard />
            <SummaryCard
                title="Next recurring invoice total"
                isLoading={isUpcomingInvoiceLoading}
                data-testid="next-invoice-total-content"
            >
                <SummaryCardBody>
                    {!isNil(nextInvoiceTotalCents) ? (
                        <DisplayCurrency
                            value={nextInvoiceTotalCents}
                            currency={upcomingInvoice?.data?.currency}
                            cents
                        />
                    ) : (
                        'N/A'
                    )}
                </SummaryCardBody>
                <SummaryCardButton href="/payment">View subscription</SummaryCardButton>
            </SummaryCard>
        </SummaryCardRow>
    );
};
